import Vue from 'vue'
import {Fragment} from 'vue-fragment'

Vue.component('fragment', Fragment)